// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".common-round-btn {\n  border-radius: 36.5px;\n  height: 48px;\n  margin: 0px;\n}\n.cancel-btn {\n  border-color: rgba(48,48,48,0.46);\n  font-weight: bold;\n  margin-right: 12px;\n  width: 100px;\n}\n.confirm-btn {\n  border-color: #FF6A57;\n  font-weight: bold;\n  margin-left: 12px;\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
